export function ensureModuleWithInit(loadModule, options = {}) {
  return loadModule().then((mod) => {
    const {
      isInitializedExport = '',
      initExport = '',
      createInitContext = null
    } = options;

    const isInitialized = typeof mod?.[isInitializedExport] === 'function'
      ? Boolean(mod[isInitializedExport]())
      : false;

    if (!isInitialized && typeof mod?.[initExport] === 'function') {
      if (typeof createInitContext === 'function') {
        mod[initExport](createInitContext());
      } else {
        mod[initExport]();
      }
    }

    return mod;
  });
}

export function invokeLazyModuleMethod(ensureModuleReady, fnName, args = [], onError = null) {
  ensureModuleReady()
    .then((mod) => {
      const fn = mod?.[fnName];
      if (typeof fn === 'function') {
        fn(...args);
      }
    })
    .catch(() => {
      if (typeof onError === 'function') onError();
    });
}

export function invokeModuleMethod(getModuleApi, ensureModuleReady, fnName, args = [], onError = null) {
  const api = typeof getModuleApi === 'function' ? getModuleApi() : null;
  const apiFn = api?.[fnName];
  if (typeof apiFn === 'function') {
    apiFn(...args);
    return;
  }
  invokeLazyModuleMethod(ensureModuleReady, fnName, args, onError);
}
